
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lpfM9", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $jmjWc = parcelRequire("jmjWc");

const $d8af34c11b1c225c$var$createLoadingComponent = ()=>{
    return (0, $fwDOR.default)({
        name: 'LoadingConfluenceRightPanelBundle'
    });
};

const $d8af34c11b1c225c$export$bec010aa49373196 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mQOM4",
    name: "PanelLoader",
    loader: async ()=>(await (parcelRequire("lksUt"))).RightPanel,
    loading: $d8af34c11b1c225c$var$createLoadingComponent
});
module.exports["PanelLoader"] = $d8af34c11b1c225c$export$bec010aa49373196;

});

parcelRegister("lksUt", function(module, exports) {

let $f871e422ec008c05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f871e422ec008c05$var$load("kAAjo"),
    $f871e422ec008c05$var$load("fbRdC"),
    $f871e422ec008c05$var$load("6wr18"),
    $f871e422ec008c05$var$load("ko0oH"),
    $f871e422ec008c05$var$load("2O2Xv"),
    $f871e422ec008c05$var$load("5UCxV"),
    $f871e422ec008c05$var$load("auWOX"),
    $f871e422ec008c05$var$load("736as"),
    $f871e422ec008c05$var$load("8VT23"),
    $f871e422ec008c05$var$load("kPclQ"),
    $f871e422ec008c05$var$load("7EorR"),
    $f871e422ec008c05$var$load("9ijrN"),
    $f871e422ec008c05$var$load("Wowvf"),
    $f871e422ec008c05$var$load("ffEVr"),
    $f871e422ec008c05$var$load("cyGuT"),
    $f871e422ec008c05$var$load("hhss7"),
    $f871e422ec008c05$var$load("8m8aj"),
    $f871e422ec008c05$var$load("lT67w"),
    $f871e422ec008c05$var$load("iZU4p"),
    $f871e422ec008c05$var$load("efnul"),
    $f871e422ec008c05$var$load("cvXSy")
]).then(()=>parcelRequire('8CeBV'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("hsPNq", function(module, exports) {
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $dEIJ1 = parcelRequire("dEIJ1");


var $8zs3p = parcelRequire("8zs3p");


var $efXed = parcelRequire("efXed");





var $f5yHb = parcelRequire("f5yHb");


var $aGop9 = parcelRequire("aGop9");

/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $c1ceb78a17a4a48e$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $c1ceb78a17a4a48e$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $c1ceb78a17a4a48e$var$linearizeRGBChannel(normal.r),
        g: $c1ceb78a17a4a48e$var$linearizeRGBChannel(normal.g),
        b: $c1ceb78a17a4a48e$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $c1ceb78a17a4a48e$var$flipLuminance = 0.179129;
function $c1ceb78a17a4a48e$export$44af652f4cca9039(color) {
    return $c1ceb78a17a4a48e$var$relativeLuminanceW3C(color) >= $c1ceb78a17a4a48e$var$flipLuminance;
}
function $c1ceb78a17a4a48e$export$5573a5bab3e074b5(backgroundColor) {
    if ($c1ceb78a17a4a48e$var$relativeLuminanceW3C(backgroundColor) >= $c1ceb78a17a4a48e$var$flipLuminance) return 'light';
    return 'dark';
}
const $c1ceb78a17a4a48e$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $c1ceb78a17a4a48e$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $c1ceb78a17a4a48e$export$5573a5bab3e074b5(backgroundColor);
    return $c1ceb78a17a4a48e$var$textColor[colorMode];
}
function $c1ceb78a17a4a48e$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}



var $9h83k = parcelRequire("9h83k");

/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ const $6eb7eca8acfb9579$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
const $6eb7eca8acfb9579$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};



var $cAraS = parcelRequire("cAraS");

function $c9a912eb0ce01068$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $c9a912eb0ce01068$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $c9a912eb0ce01068$var$buttonStyles = {
    light: {
        [(0, $aGop9.themedButtonBackground)]: 'transparent',
        [(0, $aGop9.themedButtonBackgroundHovered)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral200A,
        [(0, $aGop9.themedButtonBackgroundPressed)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral300A,
        [(0, $aGop9.themedButtonBorder)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral300A,
        [(0, $aGop9.themedButtonSelectedBackground)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral300A,
        [(0, $aGop9.themedButtonSelectedBackgroundHovered)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral400A,
        [(0, $aGop9.themedButtonSelectedBackgroundPressed)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral500A,
        [(0, $aGop9.themedButtonDisabledText)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral400A,
        [(0, $aGop9.themedButtonDisabledBackground)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral100A
    },
    dark: {
        [(0, $aGop9.themedButtonBackground)]: 'transparent',
        [(0, $aGop9.themedButtonBackgroundHovered)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral200A,
        [(0, $aGop9.themedButtonBackgroundPressed)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral300A,
        [(0, $aGop9.themedButtonBorder)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral300A,
        [(0, $aGop9.themedButtonSelectedBackground)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral300A,
        [(0, $aGop9.themedButtonSelectedBackgroundHovered)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral400A,
        [(0, $aGop9.themedButtonSelectedBackgroundPressed)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral500A,
        [(0, $aGop9.themedButtonDisabledText)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral400A,
        [(0, $aGop9.themedButtonDisabledBackground)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral100A
    }
};
const $c9a912eb0ce01068$var$logoStyles = {
    light: {
        [(0, $f5yHb.themedLogoIcon)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral0,
        [(0, $f5yHb.themedLogoText)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral0
    },
    dark: {
        [(0, $f5yHb.themedLogoIcon)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral0,
        [(0, $f5yHb.themedLogoText)]: (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral0
    }
};
function $c9a912eb0ce01068$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $9h83k.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $9h83k.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $c1ceb78a17a4a48e$export$5357fe757c335c0d)(backgroundRgb);
    const colorMode = (0, $c1ceb78a17a4a48e$export$5573a5bab3e074b5)(backgroundRgb);
    const highlightTextColor = (0, $c1ceb78a17a4a48e$export$5357fe757c335c0d)(highlightRgb);
    return {
        backgroundColor: $c9a912eb0ce01068$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$c9a912eb0ce01068$var$buttonStyles[colorMode],
        ...$c9a912eb0ce01068$var$logoStyles[colorMode],
        ...$c9a912eb0ce01068$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $cAraS.themedSearchBorder)]: $c9a912eb0ce01068$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $cAraS.themedSearchBorderFocused)]: $c9a912eb0ce01068$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ [(0, $aGop9.themedButtonPrimaryBackground)]: $c9a912eb0ce01068$var$toRGBString(highlightRgb),
        [(0, $aGop9.themedButtonPrimaryBackgroundHovered)]: $c9a912eb0ce01068$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        [(0, $aGop9.themedButtonPrimaryBackgroundPressed)]: $c9a912eb0ce01068$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        [(0, $aGop9.themedButtonPrimaryText)]: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $c9a912eb0ce01068$var$selectedBackgroundRGBA = {
    light: (0, $6eb7eca8acfb9579$export$c9b84419dae66a82).Neutral300A,
    dark: (0, $6eb7eca8acfb9579$export$c9b84419dae66a82).DarkNeutral300A
};
function $c9a912eb0ce01068$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $c9a912eb0ce01068$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $c1ceb78a17a4a48e$export$e5e64c30bee1469b)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        [(0, $aGop9.themedButtonSelectedText)]: (0, $c1ceb78a17a4a48e$export$5357fe757c335c0d)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        [(0, $aGop9.themedButtonSelectedBorder)]: (0, $c1ceb78a17a4a48e$export$44af652f4cca9039)(blendedBackground) ? (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).Neutral1100 : (0, $6eb7eca8acfb9579$export$eaad8caa32d2521d).DarkNeutral1100
    };
}


function $01d61109d9017720$export$c0c5f5b297b77726(theme) {
    const value = (0, $42omo.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $c9a912eb0ce01068$export$3986d75fe2da3239)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}



var $K0HEo = parcelRequire("K0HEo");


var $8jREP = parcelRequire("8jREP");


var $dGAIk = parcelRequire("dGAIk");


var $bgZhH = parcelRequire("bgZhH");


var $7R2w7 = parcelRequire("7R2w7");


var $fOzFY = parcelRequire("fOzFY");

const $dc553dad5be74d31$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179ria51 _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i1dgc _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1j8b18ax",
    fullHeightSidebar: "_18zrze3t _179rglyw _bfhkglyw _lcxvglyw _pdlmutpp",
    fullHeightSidebarExpanded: "_1rqt16a9 _jh1g18ax",
    fullHeightSidebarWithLayeringFixes: "_1pbycs5v _lcxv1wug _bfhkvuon _aetrb3bt _18postnw _1gufidpf _1czdidpf _g0nf3tht _1beue4h9 _uaeunqa1 _1cte1l7x",
    fullHeightSidebarWithLayeringFixesAndOpenLayer: "_1pby11wp"
}; /**
    * Styles for the visible 'bar' of the top nav, including background and border.
    *
    * This is on a lower z-index than the expanded side nav, and is separate to the top nav items which are above the expanded side nav.
    */ 
const $dc553dad5be74d31$var$backgroundStyles = {
    root: "_nd5l8cbt _179ria51 _1bsb1osq _4t3i1osq _bfhkvuon _vchhusvi _152t1nws _kqsw1if8 _lcxvglyw _1pbyegat",
    sideNavExpanded: "_hyzqcs5v"
}; /**
    * Namespaces to check for open layers within the top nav.
    * When there is an open layer in the top nav, the top nav is given a higher z-index than the side nav.
    *
    * Placed outside the component for stability, as the list is used as an effect dependency.
    */ 
const $dc553dad5be74d31$var$topNavOpenLayerNamespaces = [
    (0, $K0HEo.openLayerObserverTopNavStartNamespace),
    (0, $K0HEo.openLayerObserverTopNavMiddleNamespace),
    (0, $K0HEo.openLayerObserverTopNavEndNamespace)
]; /**
                                                                                                                                                         * The top nav layout area. It will display at the top of the screen, below the banner if one is present.
                                                                                                                                                         */ 
function $dc553dad5be74d31$export$41d0d88a6b0e456f({ children: children, xcss: xcss, height: height = 48, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, UNSAFE_theme: UNSAFE_theme }) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const dangerouslyHoistSlotSizes = (0, $42omo.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    (0, $dEIJ1.useSkipLink)(id, skipLinkLabel);
    const customTheme = (0, $01d61109d9017720$export$c0c5f5b297b77726)(UNSAFE_theme); /**
                                                    * Note: this is no longer the case when fg('platform-dst-side-nav-layering-fixes') is enabled.
                                                    *
                                                    * With the full height sidebar we have a foreground and background element,
                                                    * so we need to apply the custom theme styles to the correct element.
                                                    *
                                                    * The foreground element should not have a background color,
                                                    * and the background element doesn't need any of the other styles.
                                                    */ 
    const { backgroundStyle: backgroundStyle, foregroundStyle: foregroundStyle } = (0, $42omo.useMemo)(()=>{
        if (!customTheme.isEnabled) return {
            backgroundStyle: undefined,
            foregroundStyle: undefined
        };
        const { backgroundColor: backgroundColor, ...foregroundStyle } = customTheme.style;
        return {
            backgroundStyle: {
                backgroundColor: backgroundColor
            },
            foregroundStyle: foregroundStyle
        };
    }, [
        customTheme
    ]);
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $7R2w7.useSideNavVisibility)();
    const hasOpenPopup = (0, $fOzFY.useHasOpenLayers)({
        namespaces: $dc553dad5be74d31$var$topNavOpenLayerNamespaces,
        type: 'popup'
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $efXed.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: [
            isFhsEnabled && !(0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                "data-layout-slot": true,
                "aria-hidden": true,
                style: isFhsEnabled ? backgroundStyle : undefined,
                className: (0, $gMc0m.default)([
                    $dc553dad5be74d31$var$backgroundStyles.root,
                    isExpandedOnDesktop && $dc553dad5be74d31$var$backgroundStyles.sideNavExpanded
                ])
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("header", {
                id: id,
                "data-layout-slot": true,
                className: (0, $gMc0m.default)([
                    $dc553dad5be74d31$var$styles.root,
                    isFhsEnabled && $dc553dad5be74d31$var$styles.fullHeightSidebar,
                    isFhsEnabled && (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && $dc553dad5be74d31$var$styles.fullHeightSidebarWithLayeringFixes,
                    hasOpenPopup && isFhsEnabled && (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && $dc553dad5be74d31$var$styles.fullHeightSidebarWithLayeringFixesAndOpenLayer,
                    isExpandedOnDesktop && isFhsEnabled && $dc553dad5be74d31$var$styles.fullHeightSidebarExpanded,
                    xcss
                ]),
                "data-testid": testId,
                style: // When the layering fixes are enabled, we no longer have separate elements for the foreground and background.
                isFhsEnabled && !(0, $dh538.fg)('platform-dst-side-nav-layering-fixes') ? foregroundStyle : customTheme.isEnabled ? customTheme.style : undefined,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dGAIk.HoistCssVarToLocalGrid), {
                        variableName: (0, $K0HEo.topNavMountedVar),
                        value: height
                    }),
                    dangerouslyHoistSlotSizes && /*#__PURE__*/ (0, $l998X.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $K0HEo.UNSAFE_topNavVar),
                        value: height
                    }),
                    children
                ]
            })
        ]
    });
}
module.exports["TopNav"] = $dc553dad5be74d31$export$41d0d88a6b0e456f;

});

parcelRegister("dTIqH", function(module, exports) {
/* top-nav-end.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $bNwbD = parcelRequire("bNwbD");


var $9VJDA = parcelRequire("9VJDA");


var $fQcKS = parcelRequire("fQcKS");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $2hNw6 = parcelRequire("2hNw6");


var $dM2NO = parcelRequire("dM2NO");


var $8zs3p = parcelRequire("8zs3p");


var $efXed = parcelRequire("efXed");


var $aaBfd = parcelRequire("aaBfd");


var $K0HEo = parcelRequire("K0HEo");

const $3237f96d3246ddc1$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg _1d2y1ris _glte1ris _15rip2n4 _1gs5usvi _ndwch9n0",
    fullHeightSidebar: "_y4tiutpp _lcxv1wug",
    fullHeightSidebarWithLayeringFixes: "_y4tiutpp"
};
const $3237f96d3246ddc1$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
};
function $3237f96d3246ddc1$var$OpenLayerObserverNamespaceProviderBehindFG({ children: children }) {
    return (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fQcKS.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $K0HEo.openLayerObserverTopNavEndNamespace),
        children: children
    }) : children;
}
function $3237f96d3246ddc1$export$8b7a38b70a3c9839({ children: children, label: label = 'Actions', showMoreButtonLabel: showMoreButtonLabel = 'Show more' }) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false); // Always setting to `false` for the initial render (will flip in an effect for mobile)
    const [isMobile, setIsMobile] = (0, $42omo.useState)(false); // Note: `query` is a stable value between renders
    const query = (0, $2hNw6.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches); // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $bNwbD.useLayoutEffect)(()=>{
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile(query?.matches ?? false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("nav", {
        "aria-label": label,
        className: (0, $gMc0m.default)([
            $3237f96d3246ddc1$var$containerStyles.root,
            isFhsEnabled && !(0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && $3237f96d3246ddc1$var$containerStyles.fullHeightSidebar,
            isFhsEnabled && (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && $3237f96d3246ddc1$var$containerStyles.fullHeightSidebarWithLayeringFixes
        ]),
        children: isMobile ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-start",
            shouldRenderToParent: true,
            content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $efXed.HasCustomThemeContext).Provider, {
                    value: false,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dM2NO.List), {
                        xcss: (0, $1bHXt.cx)($3237f96d3246ddc1$var$listStyles.root, $3237f96d3246ddc1$var$listStyles.popupContainer),
                        children: /*#__PURE__*/ (0, $l998X.jsx)($3237f96d3246ddc1$var$OpenLayerObserverNamespaceProviderBehindFG, {
                            children: children
                        })
                    })
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                    ...triggerProps,
                    label: showMoreButtonLabel,
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    isTooltipDisabled: false
                })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $dM2NO.List), {
            xcss: (0, $1bHXt.cx)($3237f96d3246ddc1$var$listStyles.root, $3237f96d3246ddc1$var$listStyles.hideOnSmallViewport),
            children: /*#__PURE__*/ (0, $l998X.jsx)($3237f96d3246ddc1$var$OpenLayerObserverNamespaceProviderBehindFG, {
                children: children
            })
        })
    });
}
module.exports["TopNavEnd"] = $3237f96d3246ddc1$export$8b7a38b70a3c9839;

});

parcelRegister("idPUB", function(module, exports) {
/* top-nav-middle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $fQcKS = parcelRequire("fQcKS");


var $dh538 = parcelRequire("dh538");


var $8zs3p = parcelRequire("8zs3p");


var $K0HEo = parcelRequire("K0HEo");

const $914f9bcda81973a9$var$styles = {
    root: "_zulpu2gc _yyhycs5v _1bsb1osq _4cvr1h6o _1e0c1txw _1bahh9n0 _181n11p5 _1j8b15b0 _lagd1bp4 _1t4c1ris _12e8h9n0",
    fullHeightSidebar: "_lcxv1wug"
}; /**
    * __TopNavMiddle__
    *
    * Wrapper for the actions in the middle of the top navigation.
    *
    * Expects that the search bar is the first child.
    * If it is not, you might see unexpected layout behavior.
    */ 
function $914f9bcda81973a9$export$88836ac6da0f492f({ children: children }) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $914f9bcda81973a9$var$styles.root,
            isFhsEnabled && !(0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && $914f9bcda81973a9$var$styles.fullHeightSidebar
        ]),
        children: (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fQcKS.OpenLayerObserverNamespaceProvider), {
            namespace: (0, $K0HEo.openLayerObserverTopNavMiddleNamespace),
            children: children
        }) : children
    });
}
module.exports["TopNavMiddle"] = $914f9bcda81973a9$export$88836ac6da0f492f;

});

parcelRegister("9vGun", function(module, exports) {
/* top-nav-start.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $g6aM3 = parcelRequire("g6aM3");


var $fQcKS = parcelRequire("fQcKS");


var $dh538 = parcelRequire("dh538");


var $2hNw6 = parcelRequire("2hNw6");


var $7plVH = parcelRequire("7plVH");


var $8zs3p = parcelRequire("8zs3p");


var $K0HEo = parcelRequire("K0HEo");


var $7R2w7 = parcelRequire("7R2w7");


var $cvtof = parcelRequire("cvtof");

const $5ef6b118a2e92a48$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1; // Placed in a variable, as the value is used in the translateX value for the children wrapper animation.
const $5ef6b118a2e92a48$var$flexGap = "var(--ds-space-050, 4px)"; /**
                                             * Styles for the TopNavStart element.
                                             *
                                             * When `useIsFhsEnabled` is true this is the styling for the inner element,
                                             * which re-enables pointer events.
                                             */ 
const $5ef6b118a2e92a48$var$innerStyles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw _glte1ris _15rip2n4 _1gs5usvi",
    fullHeightSidebar: "_lcxv1wug",
    fullHeightSidebarExpanded: "_15rin7od _glte1osq"
}; /**
    * The scroll indicator is usually applied in SideNavContent, but if there is no SideNavHeader it is
    * applied in TopNavStart instead for layering reasons. See the comment in SideNavHeader for more details.
    */ 
const $5ef6b118a2e92a48$var$scrolledShadow = null; /**
                              * Styles for the outer element, that does not have re-enabled pointer events and spans the entire
                              * width of the TopNavStart area.
                              *
                              * This wrapper element is only rendered when `useIsFhsEnabled` is true.
                              */ 
const $5ef6b118a2e92a48$var$wrapperStyles = {
    root: "_vchhusvi _bozgutpp _4t3i1osq",
    fullHeightSidebarExpanded: "_glte93mn _exxmpxbi",
    fullHeightSidebarWithLayeringFixes: "_13wnh2mm _1l3vb3bt _juxdstnw _1vinidpf _1719idpf _e6znidpf _1kyhe4h9 _4cwynqa1 _435s1l7x _m7c3idpf",
    fullHeightSidebarExpandedWithLayeringFixes: "_4ap3vuon _1kilgc9s _1m3lsjnm _12g81hrf _m7c3kb7n",
    fullHeightSidebarBorderTransition: "_n8qabrmi _wc72fnf5 _j3mr1v42"
};
/**
 * We use a fixed translateX offset for the slide animation (used when the TopNavStart children elements are reordered).
 * This fixed offset makes the elements appear to animate smoothly from the old to the new position.
 * This offset is calculated based on:
 * - 32px (2rem) width of the side nav toggle button (IconButton)
 * - 4px gap ('space.050' token) of the flex container
 *
 * The benefit of hardcoding this offset is that we don't need to calculate it using JS each time the sidebar is toggled.
 * However, it could become out of sync if the width of IconButton changes.
 *
 * The alternative is using JS to store the previous position of the children wrapper element, and calculate the offset based on
 * the new position, and then transforming using that offset. This would prevent the animation from going out of sync.
 */ const $5ef6b118a2e92a48$var$childrenWrapperAnimationOffset = `calc(2rem + ${$5ef6b118a2e92a48$var$flexGap})`;
const $5ef6b118a2e92a48$var$childrenWrapperStyles = {
    root: "_zulp1kw7 _1e0c1kw7 _4cvr1h6o _1ul9idpf _15yekb7n _65m41mrw",
    animationBaseStyles: "_10t81e03",
    finalPosition: "_mjvcz12g _xrrpfnf5",
    expandAnimationStartPosition: "_mjvcyrjp",
    collapseAnimationStartPosition: "_mjvco0k7"
}; /**
    * We use a fixed translateX offset for the toggle button slide animation (used when the TopNavStart children elements are reordered).
    * The specific value doesn't matter too much for the toggle button animation, so we are using `100%`, which will match the toggle button width.
    *
    * By combining the `translateX` animation with an `opacity` fade, the feel and experience is actually quite similar to animating the
    * element from the exact old position (offset), and it avoids the additional complexity of needing to track and calculate the exact offset.
    */ 
const $5ef6b118a2e92a48$var$toggleButtonWrapperStyles = {
    root: "_15yekb7n _65m41mrw _10t81rjc",
    finalPosition: "_mjvcz12g _xrrpfnf5 _bgpzkb7n",
    expandAnimationStartPosition: "_mjvc1p9u _bgpzidpf",
    collapseAnimationStartPosition: "_mjvc1efy _bgpzidpf",
    expandAnimationTimingFunction: "_1xq51ytf",
    collapseAnimationTimingFunction: "_1xq55ucs",
    alignEnd: "_ahbq1wug"
}; /**
    * The consistent key used for the side nav toggle button to ensure it does not get remounted
    * when it is reordered.
    *
    * This ensures we get focus restoration for free.
    */ 
const $5ef6b118a2e92a48$var$sideNavToggleButtonKey = 'side-nav-toggle-button';
const $5ef6b118a2e92a48$var$TopNavStartInnerOld = /*#__PURE__*/ (0, $42omo.forwardRef)(function TopNavStartInner({ children: children, testId: testId }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $5ef6b118a2e92a48$var$innerStyles.root
        ]),
        children: children
    });
});
const $5ef6b118a2e92a48$var$TopNavStartInnerFHS = /*#__PURE__*/ (0, $42omo.forwardRef)(function TopNavStartInnerFHS({ children: children, testId: testId }, ref) {
    // This needs the real `defaultCollapsed` state or will not SSR properly
    // TODO: lift `defaultCollapsed` state to `Root` (DSP-23683)
    // then context value will be correct in SSR / from initial render
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $7R2w7.useSideNavVisibility)({
        defaultCollapsed: true
    });
    const sideNavState = (0, $42omo.useContext)((0, $cvtof.SideNavVisibilityState));
    const isFirstRenderRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform-dst-side-nav-layering-fixes')) return;
         // Ignore renders until the side nav state is initialized
        // So that apps using the legacy API for setting side nav default state do not see
        // animations when they shouldn't
        if (sideNavState === null) return;
        if (isFirstRenderRef.current) isFirstRenderRef.current = false;
    }, [
        sideNavState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $5ef6b118a2e92a48$var$wrapperStyles.root,
            isExpandedOnDesktop && $5ef6b118a2e92a48$var$wrapperStyles.fullHeightSidebarExpanded,
            (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && $5ef6b118a2e92a48$var$wrapperStyles.fullHeightSidebarWithLayeringFixes,
            !isFirstRenderRef.current && isExpandedOnDesktop && (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && $5ef6b118a2e92a48$var$wrapperStyles.fullHeightSidebarBorderTransition,
            isExpandedOnDesktop && (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && $5ef6b118a2e92a48$var$wrapperStyles.fullHeightSidebarExpandedWithLayeringFixes
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ref: ref,
            "data-testid": testId,
            className: (0, $gMc0m.default)([
                $5ef6b118a2e92a48$var$innerStyles.root,
                !(0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && $5ef6b118a2e92a48$var$innerStyles.fullHeightSidebar,
                isExpandedOnDesktop && $5ef6b118a2e92a48$var$innerStyles.fullHeightSidebarExpanded
            ]),
            children: (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fQcKS.OpenLayerObserverNamespaceProvider), {
                namespace: (0, $K0HEo.openLayerObserverTopNavStartNamespace),
                children: children
            }) : children
        })
    });
});
function $5ef6b118a2e92a48$export$4c15269b98c5129({ children: children, testId: testId, sideNavToggleButton: sideNavToggleButton }) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const ref = (0, $42omo.useContext)((0, $7plVH.TopNavStartAttachRef));
    const elementRef = (0, $42omo.useRef)(null); // FIXME: unsafe pattern with Suspense, should use callback ref / store in state
    // Should handle the underlying HTMLElement changing without a remount
    (0, $42omo.useEffect)(()=>{
        ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]); // This needs the real `defaultCollapsed` state or will not SSR properly
    // TODO: lift `defaultCollapsed` state to `Root` (DSP-23683)
    // then context value will be correct in SSR / from initial render
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $7R2w7.useSideNavVisibility)({
        defaultCollapsed: true
    }); // For SSR assume desktop
    const [isDesktop, setIsDesktop] = (0, $42omo.useState)(true); // Set state to real value on client
    // This could result in some visible shift on mobile when hydrating SSR
    // TODO: review and improve SSR behavior as necessary (DSP-23817)
    (0, $42omo.useLayoutEffect)(()=>{
        // Checking this to avoid breaking tests when `matchMedia` is not mocked
        // Ideally we wouldn't cater to test environments, but this avoids introducing unnecessary friction
        if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') setIsDesktop(window.matchMedia('(min-width: 64rem)').matches);
    }, []);
    (0, $2hNw6.UNSAFE_useMediaQuery)('above.md', (event)=>{
        setIsDesktop(event.matches);
    });
    const [animationState, setAnimationState] = (0, $42omo.useState)({
        type: 'idle'
    }); // Used to prevent the reorder animations from running on the initial render.
    const isFirstRenderRef = (0, $42omo.useRef)(true);
    const sideNavState = (0, $42omo.useContext)((0, $cvtof.SideNavVisibilityState));
    (0, $42omo.useEffect)(()=>{
        if (!isFhsEnabled) return;
         // Ignore renders until the side nav state is initialized
        // So that apps using the legacy API for setting side nav default state do not see
        // animations when they shouldn't
        if (sideNavState === null) return;
        if (isFirstRenderRef.current) isFirstRenderRef.current = false;
    }, [
        isFhsEnabled,
        sideNavState
    ]); // Using a stable ref to avoid re-running the animation layout effect when the toggle button prop value changes, which
    // can happen a lot (e.g. if the parent re-renders)
    const sideNavToggleButtonStableRef = (0, $g6aM3.default)(sideNavToggleButton);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isFhsEnabled) return;
         /**
      * This layout effect is used to animate the TopNavStart children elements to their new position after being reordered.
      * It is called when the sidebar's desktop expansion state changes.
      *
      * It works by first setting a translateX offset on the elements, used as the start position of the slide animation.
      * - For the toggle button, it's a fixed offset. It's combined with an opacity, so the exact offset doesn't matter too much.
      * - For the children wrapper (wrapping everything except the toggle button), an offset was chosen to make the animation
      * start position the exact same as the element's old position. See comments for `childrenWrapperStyles` for more details.
      *
      * On the next frame, the translateX offset is cleared, triggering the animation to the new position.
      */ 
        if (isFirstRenderRef.current) // No animations on initial render.
        return;
        if (!sideNavToggleButtonStableRef.current) // If there is no toggle button, there should be no re-order animations.
        return;
         // Set the translateX offsets so elements are ready to animate to their actual new position after being reordered
        setAnimationState({
            type: isExpandedOnDesktop ? 'expand' : 'collapse'
        });
        requestAnimationFrame(()=>{
            // Clear translateX offsets on next frame to trigger animation to new position in a re-render
            setAnimationState({
                type: 'idle'
            });
        }); // This layout effect is called when the sidebar's desktop expansion state changes.
    }, [
        isExpandedOnDesktop,
        isFhsEnabled,
        sideNavToggleButtonStableRef
    ]);
    const TopNavStartInner = isFhsEnabled ? $5ef6b118a2e92a48$var$TopNavStartInnerFHS : $5ef6b118a2e92a48$var$TopNavStartInnerOld;
    return /*#__PURE__*/ (0, $l998X.jsxs)(TopNavStartInner, {
        ref: elementRef,
        testId: testId,
        children: [
            !isFhsEnabled && sideNavToggleButton,
            sideNavToggleButton && (!isDesktop || !isExpandedOnDesktop) && isFhsEnabled && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    !$5ef6b118a2e92a48$var$isFirefox && $5ef6b118a2e92a48$var$toggleButtonWrapperStyles.root,
                    !$5ef6b118a2e92a48$var$isFirefox && animationState.type === 'idle' && $5ef6b118a2e92a48$var$toggleButtonWrapperStyles.finalPosition,
                    !$5ef6b118a2e92a48$var$isFirefox && // Timing function is applied when the browser animates to the idle position.
                    animationState.type === 'idle' && $5ef6b118a2e92a48$var$toggleButtonWrapperStyles.collapseAnimationTimingFunction,
                    !$5ef6b118a2e92a48$var$isFirefox && animationState.type === 'collapse' && $5ef6b118a2e92a48$var$toggleButtonWrapperStyles.collapseAnimationStartPosition
                ]),
                children: sideNavToggleButton
            }, $5ef6b118a2e92a48$var$sideNavToggleButtonKey),
            isFhsEnabled ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $5ef6b118a2e92a48$var$childrenWrapperStyles.root,
                    !$5ef6b118a2e92a48$var$isFirefox && $5ef6b118a2e92a48$var$childrenWrapperStyles.animationBaseStyles,
                    !$5ef6b118a2e92a48$var$isFirefox && animationState.type === 'idle' && $5ef6b118a2e92a48$var$childrenWrapperStyles.finalPosition,
                    !$5ef6b118a2e92a48$var$isFirefox && animationState.type === 'expand' && $5ef6b118a2e92a48$var$childrenWrapperStyles.expandAnimationStartPosition,
                    !$5ef6b118a2e92a48$var$isFirefox && animationState.type === 'collapse' && $5ef6b118a2e92a48$var$childrenWrapperStyles.collapseAnimationStartPosition
                ]),
                children: children
            }) : children,
            sideNavToggleButton && isDesktop && isExpandedOnDesktop && isFhsEnabled && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    !$5ef6b118a2e92a48$var$isFirefox && $5ef6b118a2e92a48$var$toggleButtonWrapperStyles.root,
                    $5ef6b118a2e92a48$var$toggleButtonWrapperStyles.alignEnd,
                    !$5ef6b118a2e92a48$var$isFirefox && animationState.type === 'idle' && $5ef6b118a2e92a48$var$toggleButtonWrapperStyles.finalPosition,
                    !$5ef6b118a2e92a48$var$isFirefox && // Timing function is applied when the browser animates to the idle position.
                    animationState.type === 'idle' && $5ef6b118a2e92a48$var$toggleButtonWrapperStyles.expandAnimationTimingFunction,
                    !$5ef6b118a2e92a48$var$isFirefox && animationState.type === 'expand' && $5ef6b118a2e92a48$var$toggleButtonWrapperStyles.expandAnimationStartPosition
                ]),
                children: sideNavToggleButton
            }, $5ef6b118a2e92a48$var$sideNavToggleButtonKey)
        ]
    });
}
module.exports["TopNavStart"] = $5ef6b118a2e92a48$export$4c15269b98c5129;

});

parcelRegister("eBBZq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $4kfV4 = parcelRequire("4kfV4");


var $fj1Kw = parcelRequire("fj1Kw");


var $f1YjX = parcelRequire("f1YjX");

var $dq4RI = parcelRequire("dq4RI");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $bQm3c = parcelRequire("bQm3c");





var $cm2rU = parcelRequire("cm2rU");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $emHKt = parcelRequire("emHKt");

var $2uNd6 = parcelRequire("2uNd6");

var $hNJxa = parcelRequire("hNJxa");


var $9QvUi = parcelRequire("9QvUi");





var $7aRa9 = parcelRequire("7aRa9");


var $1Y265 = parcelRequire("1Y265");

const $a17e741d85380f31$var$maxHeightWrapper = (0, $ecnYn.xcss)({
    maxHeight: 'calc(100vh - 100px)'
});
const $a17e741d85380f31$var$joinableProductsInSwitcherProvider = (0, $emHKt.createJoinableSitesProvider)((0, $hNJxa.fetchProductRecommendationsWithCollaborators)('/gateway/api/invitations'));
const $a17e741d85380f31$export$635f95e4f8a4fd7c = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const customShowFlagMemo = (0, $42omo.useMemo)(()=>(0, $1Y265.customShowFlag)(flags), [
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a17e741d85380f31$var$maxHeightWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2uNd6.AtlassianSwitcherLoader), {
        product: "confluence",
        cloudId: cloudId,
        joinableSitesDataProvider: $a17e741d85380f31$var$joinableProductsInSwitcherProvider,
        showFlag: customShowFlagMemo,
        discoverySection: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9QvUi.default), {
            placementId: "app-switcher-discovery-section",
            // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
            PlacementComponent: (0, $cm2rU.default)
        })
    }));
});


const $4ea98e6e25820b6e$export$66169bdb3eb9897d = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(13);
    const intl = (0, $8C5kA.default)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isOpen || $[2] !== routeDataRef) {
        t0 = ()=>{
            if (!isOpen) (0, $dq4RI.setSwitcherRenderStartMark)();
            setIsOpen(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "atlassianSwitcher",
                    attributes: {
                        selectedItemPageContext: routeDataRef.current?.routeName,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isOpen;
        $[2] = routeDataRef;
        $[3] = t0;
    } else t0 = $[3];
    const onClick = t0;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsOpen(false);
        };
        $[4] = t1;
    } else t1 = $[4];
    const onClose = t1;
    let t2;
    if ($[5] !== cloudId || $[6] !== intl || $[7] !== isOpen || $[8] !== onClick) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1YjX.default), {
                cloudId: cloudId,
                product: "confluence"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fj1Kw.AppSwitcher), {
                label: intl.formatMessage($4ea98e6e25820b6e$var$i18n.switcher),
                isSelected: isOpen,
                onClick: onClick,
                interactionName: "confluence_app_switcher"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                isTinted: false,
                shouldAllowClickThrough: !isOpen,
                onBlanketClicked: onClose
            })));
        $[5] = cloudId;
        $[6] = intl;
        $[7] = isOpen;
        $[8] = onClick;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== isOpen || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            content: $4ea98e6e25820b6e$var$_temp,
            trigger: t2,
            placement: "bottom-start",
            rootBoundary: "document"
        });
        $[10] = isOpen;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ()=>{
    const intl = (0, $8C5kA.default)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onClick = ()=>{
        if (!isOpen) (0, $dq4RI.setSwitcherRenderStartMark)();
        setIsOpen(!isOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'atlassianSwitcher',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
    const onClose = ()=>{
        setIsOpen(false);
    };
    return(// TODO: Add `shouldRenderToParent={true}` to meet a11y requirements. See
    // https://a11y.atlassian.net/browse/JCATS-788
    // https://hello.jira.atlassian.cloud/browse/DISCO-4291
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: onClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a17e741d85380f31$export$635f95e4f8a4fd7c), null),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1YjX.default), {
                cloudId: cloudId,
                product: "confluence"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fj1Kw.AppSwitcher), {
                label: intl.formatMessage($4ea98e6e25820b6e$var$i18n.switcher),
                isSelected: isOpen,
                onClick: onClick,
                interactionName: "confluence_app_switcher"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                isTinted: false,
                shouldAllowClickThrough: !isOpen,
                onBlanketClicked: onClose
            }))),
        placement: "bottom-start",
        rootBoundary: "document"
    }));
};
const $4ea98e6e25820b6e$var$i18n = (0, $cgtv4.defineMessages)({
    switcher: {
        id: "app-navigation.top-navigation.app-switcher",
        defaultMessage: "Switch sites or apps"
    }
});
function $4ea98e6e25820b6e$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a17e741d85380f31$export$635f95e4f8a4fd7c), null);
}
module.exports["AppSwitcherButton"] = $4ea98e6e25820b6e$export$66169bdb3eb9897d;

});

parcelRegister("1B659", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $c6GJD = parcelRequire("c6GJD");


var $jmjWc = parcelRequire("jmjWc");


var $gLUd5 = parcelRequire("gLUd5");


const $967ca22ab943ad07$var$BranchDeployLogoLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K2D1k",
    name: "BranchDeployLogoLoader",
    loader: async ()=>(await (parcelRequire("gO6f0"))).BranchDeployLogo,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iOozU))), {
            label: "Loading..."
        })
});

const $967ca22ab943ad07$var$FeatureFlagLogoLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gfVJ0",
    name: "FeatureFlagLogoLoader",
    loader: async ()=>(await (parcelRequire("8uq1E"))).FeatureFlagLogo
});
const $967ca22ab943ad07$export$55e9396bf1b75bb0 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { isAtlassianStaff: t1 } = t0;
    const isAtlassianStaff = t1 === undefined ? false : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gLUd5.isBranchDeployFn)();
        $[0] = t2;
    } else t2 = $[0];
    const isBranchDeploy = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $c6GJD.default).getOverrides();
        $[1] = t3;
    } else t3 = $[1];
    const featureGateOverrides = t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = Object.keys(featureGateOverrides.gates).length > 0 || Object.keys(featureGateOverrides.configs).length > 0;
        $[2] = t4;
    } else t4 = $[2];
    const hasOverrides = t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = isBranchDeploy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($967ca22ab943ad07$var$BranchDeployLogoLoader, null);
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== isAtlassianStaff) {
        t6 = isAtlassianStaff && hasOverrides && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($967ca22ab943ad07$var$FeatureFlagLogoLoader, {
            featureGateOverrides: featureGateOverrides
        });
        $[4] = isAtlassianStaff;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t6);
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    return t7;
} : ({ isAtlassianStaff: isAtlassianStaff = false })=>{
    const isBranchDeploy = (0, $gLUd5.isBranchDeployFn)();
    const featureGateOverrides = (0, $c6GJD.default).getOverrides();
    const hasOverrides = Object.keys(featureGateOverrides.gates).length > 0 || Object.keys(featureGateOverrides.configs).length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isBranchDeploy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($967ca22ab943ad07$var$BranchDeployLogoLoader, null), isAtlassianStaff && hasOverrides && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($967ca22ab943ad07$var$FeatureFlagLogoLoader, {
        featureGateOverrides: featureGateOverrides
    }));
};
module.exports["DeveloperButtons"] = $967ca22ab943ad07$export$55e9396bf1b75bb0;

});

parcelRegister("gO6f0", function(module, exports) {

let $c3c628311c23f88a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c3c628311c23f88a$var$load("beF0E"),
    $c3c628311c23f88a$var$load("8dYdP")
]).then(()=>parcelRequire('gef2L'));

});

parcelRegister("8uq1E", function(module, exports) {

let $62e550372865cb1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $62e550372865cb1b$var$load("392bg"),
    $62e550372865cb1b$var$load("Wowvf"),
    $62e550372865cb1b$var$load("bkswC")
]).then(()=>parcelRequire('lhO3J'));

});

parcelRegister("9MAeh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $74VX5 = parcelRequire("74VX5");


var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $4rwCt = parcelRequire("4rwCt");


var $inPa6 = parcelRequire("inPa6");


var $lGgRw = parcelRequire("lGgRw");


var $9Zu7R = parcelRequire("9Zu7R");


var $c3uZU = parcelRequire("c3uZU");


var $gaXc0 = parcelRequire("gaXc0");


var $gKr8t = parcelRequire("gKr8t");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $dPJCf = parcelRequire("dPJCf");


var $jmjWc = parcelRequire("jmjWc");


var $epLE5 = parcelRequire("epLE5");


var $9wGTI = parcelRequire("9wGTI");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $jMyy4 = parcelRequire("jMyy4");


var $cH0rK = parcelRequire("cH0rK");


var $f4ikL = parcelRequire("f4ikL");

const $a25a74f29b49c48c$var$fabricNotificationLogUrl = '/gateway/api/notification-log';
const $a25a74f29b49c48c$var$REFRESH_INTERVAL = 60000;
const $a25a74f29b49c48c$var$CLEAR_BADGE_TIME = 10000;
const $a25a74f29b49c48c$var$MAX_NOTIFICATION_COUNT = 9;

const $a25a74f29b49c48c$export$bae4076b81272f49 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "MEiTH",
    name: "NotificationsContentLoader",
    loader: async ()=>(await (parcelRequire("0HuIY"))).NotificationsContent
});

const $a25a74f29b49c48c$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("6IkrI"))).fireNotificationsClickedAnalytics);
class $a25a74f29b49c48c$var$EmptyNotificationLogClient extends (0, $c3uZU.NotificationLogClient) {
    countUnseenNotifications() {
        return Promise.resolve({
            count: 0
        });
    }
    constructor(){
        super('', '');
    }
}
const $a25a74f29b49c48c$var$useNotificationLogClient = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new (0, $c3uZU.NotificationLogClient)($a25a74f29b49c48c$var$fabricNotificationLogUrl, undefined);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return (0, $42omo.useMemo)(()=>new (0, $c3uZU.NotificationLogClient)($a25a74f29b49c48c$var$fabricNotificationLogUrl, undefined), []);
};
const $a25a74f29b49c48c$var$NotificationsButtonQuery = (0, $74VX5.default);
const $a25a74f29b49c48c$export$40e326b1271b1326 = ()=>{
    const notificationsButtonRef = (0, $42omo.useRef)(null);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [isCleared, setIsCleared] = (0, $42omo.useState)(false);
    const { userId: userId, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowButton = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const intl = (0, $8C5kA.default)();
    const notificationLogClient = $a25a74f29b49c48c$var$useNotificationLogClient();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const location = (0, $QU6QS.useLocation)();
    const [hasUnsavedCommentDraft, setHasUnsavedCommentDraft] = (0, $42omo.useState)(false);
    const { data: data } = (0, $jMyy4.useQueryInterop)($a25a74f29b49c48c$var$NotificationsButtonQuery, {
        client: (0, $gKr8t.getAGGClient)(),
        skip: !userId
    });
    const [unreadCount, setUnreadCount] = (0, $42omo.useState)(data?.notifications?.unseenNotificationCount || 0);
    const fireClickedAnalytics = $a25a74f29b49c48c$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef.current?.routeName);
    (0, $42omo.useEffect)(()=>{
        if (isCleared) {
            const timeout = setTimeout(()=>{
                setIsCleared(false);
            }, $a25a74f29b49c48c$var$CLEAR_BADGE_TIME);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        isCleared
    ]);
    const onClick = ()=>{
        if (isOpen) {
            if (hasUnsavedCommentDraft) {
                if (!(0, $f4ikL.confirmDiscardNotificationCommentDraft)(intl)) return;
            }
            closeNotificationsPopup();
        } else {
            performance.mark('notification.list.render.start');
            setIsCleared(true);
            setIsOpen(true);
        }
        fireClickedAnalytics();
    };
    const closeNotificationsPopup = (0, $42omo.useCallback)(()=>{
        setHasUnsavedCommentDraft(false);
        notificationsButtonRef.current?.focus();
        setIsOpen(false);
        performance.clearMarks('notification.list.render.start');
    }, []);
    const handlePopupCloseEvent = (0, $42omo.useCallback)((event)=>{
        if (hasUnsavedCommentDraft) {
            (0, $f4ikL.handlePopupCloseWithUnsavedChanges)(event, intl, closeNotificationsPopup);
            return;
        }
        closeNotificationsPopup();
    }, [
        hasUnsavedCommentDraft,
        closeNotificationsPopup,
        intl
    ]);
    // Close popup when navigation occurs
    (0, $42omo.useEffect)(()=>{
        if (isOpen && location) closeNotificationsPopup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        closeNotificationsPopup,
        location
    ]);
    (0, $42omo.useEffect)(()=>{
        notificationLogClient.countUnseenNotifications().then((res)=>{
            setUnreadCount(res.count);
            if (res.count >= 9) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'unseenNotificationsOver9'
                }
            }).fire();
        }).catch(()=>{});
    }, [
        createAnalyticsEvent,
        notificationLogClient
    ]);
    const NotificationsBadge = (0, $42omo.useMemo)(()=>()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Zu7R.NotificationIndicator), {
                onCountUpdated: (count)=>{
                    setUnreadCount(count.newCount);
                },
                notificationLogProvider: Promise.resolve(isCleared || isOpen ? new $a25a74f29b49c48c$var$EmptyNotificationLogClient() : notificationLogClient),
                refreshRate: $a25a74f29b49c48c$var$REFRESH_INTERVAL,
                ssrInitialValue: data?.notifications?.unseenNotificationCount
            });
        }, [
        isOpen,
        isCleared,
        notificationLogClient,
        data?.notifications?.unseenNotificationCount
    ]);
    const notificationsLabel = unreadCount <= $a25a74f29b49c48c$var$MAX_NOTIFICATION_COUNT ? intl.formatMessage($a25a74f29b49c48c$var$i18n.notifications, {
        count: unreadCount
    }) : intl.formatMessage($a25a74f29b49c48c$var$i18n.overNineNotifications);
    const shortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_NOTIFICATIONS_SHORTCUT)
    });
    return !shouldShowButton ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isOpen && hasUnsavedCommentDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cH0rK.UnsavedNotificationCommentDraftPrompt), {
        onConfirm: closeNotificationsPopup
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        placement: "bottom-end",
        shouldFlip: true,
        rootBoundary: "viewport",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a25a74f29b49c48c$export$bae4076b81272f49, {
                onUnsavedCommentDraft: setHasUnsavedCommentDraft
            }),
        isOpen: isOpen,
        onClose: handlePopupCloseEvent,
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gaXc0.Notifications), {
                ...triggerProps,
                badge: NotificationsBadge,
                onClick: onClick,
                isSelected: isOpen,
                label: // No shortcut on edit pages
                isLiveEditMode || isOnEditRoute || (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? notificationsLabel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    shortcut: (0, $gnkil.UNIVERSAL_NOTIFICATIONS_SHORTCUT),
                    contentBefore: notificationsLabel,
                    isTooltip: true
                }),
                shortcut: // No shortcut on edit pages
                !isLiveEditMode && !isOnEditRoute && (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? shortcutStrings : undefined,
                ref: (0, $4rwCt.mergeRefs)([
                    triggerProps.ref,
                    notificationsButtonRef
                ])
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.NOTIFICATIONS_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_NOTIFICATIONS_SHORTCUT),
        listener: onClick,
        isAppNavigationShortcut: true
    }));
};
const $a25a74f29b49c48c$var$i18n = (0, $cgtv4.defineMessages)({
    notifications: {
        id: "app-navigation.top-navigation.notifications",
        defaultMessage: "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
    },
    overNineNotifications: {
        id: "app-navigation.top-navigation.notifications.over-nine-notifications",
        defaultMessage: "Over 9 Notifications"
    },
    unsavedChanges: {
        id: "app-navigation.notifications.unsaved-changes.confirm",
        defaultMessage: "Do you want to discard this comment? Your comment will be lost if you do."
    }
});
module.exports["NotificationsButton"] = $a25a74f29b49c48c$export$40e326b1271b1326;

});

parcelRegister("0HuIY", function(module, exports) {

let $0021bd508c799fba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0021bd508c799fba$var$load("jTaSF"),
    $0021bd508c799fba$var$load("hhss7"),
    $0021bd508c799fba$var$load("8lj0L"),
    $0021bd508c799fba$var$load("jlSv2"),
    $0021bd508c799fba$var$load("1UUrt"),
    $0021bd508c799fba$var$load("amUNi"),
    $0021bd508c799fba$var$load("2haIE"),
    $0021bd508c799fba$var$load("9K4jq"),
    $0021bd508c799fba$var$load("h3ABO"),
    $0021bd508c799fba$var$load("kC80R"),
    $0021bd508c799fba$var$load("6wr18"),
    $0021bd508c799fba$var$load("b2vOD"),
    $0021bd508c799fba$var$load("fzHDF"),
    $0021bd508c799fba$var$load("lCT7Q"),
    $0021bd508c799fba$var$load("h4Nf7"),
    $0021bd508c799fba$var$load("Wowvf"),
    $0021bd508c799fba$var$load("kiGNy"),
    $0021bd508c799fba$var$load("ffEVr"),
    $0021bd508c799fba$var$load("3EXzu"),
    $0021bd508c799fba$var$load("7EorR"),
    $0021bd508c799fba$var$load("k8XPW"),
    $0021bd508c799fba$var$load("fWCRm"),
    $0021bd508c799fba$var$load("g9CVe"),
    $0021bd508c799fba$var$load("9IeAj"),
    $0021bd508c799fba$var$load("5j5Dl")
]).then(()=>parcelRequire('h4ISV'));

});

parcelRegister("6IkrI", function(module, exports) {

let $4e36b64b46714c38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e36b64b46714c38$var$load("SepNY").then(()=>parcelRequire('1FDBc'));

});

parcelRegister("cv4vy", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");




parcelRequire("42omo");


var $kLRO8 = parcelRequire("kLRO8");


var $ilSNM = parcelRequire("ilSNM");

const $07093422fbc04e7e$export$515664faa1398f37 = 'navigation';
const $07093422fbc04e7e$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};





parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

const $b51480b69b500518$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in"
});


const $739c14dbd5941201$export$5e6158d2118ae4aa = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kLRO8.Profile), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $07093422fbc04e7e$export$515664faa1398f37));
        },
        tooltip: (0, $b51480b69b500518$export$b495e6c63a3a03c1),
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ilSNM))), {
            color: "currentColor",
            label: ""
        })
    });


/* nav3.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");





var $4wwVl = parcelRequire("4wwVl");




const $581d0d4774eb5112$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $42omo.useState)('pending');
    const imgRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};



var $cgtv4 = parcelRequire("cgtv4");

const $35d50c55158ea6c2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    triggerTooltip: {
        id: "identity.account-menu.account-menu-popup.skeleton.tooltip",
        defaultMessage: "Account"
    }
});


const $84a2e3c47e22a026$var$imgStyles = null; // Also seems to affect `confluence/next/tools/config/tsconfig.platform.json`
const $84a2e3c47e22a026$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $8C5kA.default)();
    const state = (0, $581d0d4774eb5112$export$2c1df3428fc3264c)(picture || '');
    const tooltip = intl.formatMessage((0, $35d50c55158ea6c2$export$defe85febe8b728c).triggerTooltip);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kLRO8.Profile), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: picture,
            alt: tooltip,
            className: (0, $gMc0m.default)([
                "_2rko1rr0 _1bsb1ejb _4t3i1ejb"
            ])
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
            color: "currentColor",
            label: tooltip,
            spacing: "spacious"
        })
    });
});





parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $7TH2w = parcelRequire("7TH2w");


var $inPa6 = parcelRequire("inPa6");


var $jK29N = parcelRequire("jK29N");


var $lebfc = parcelRequire("lebfc");


var $6767u = parcelRequire("6767u");


var $fIcbd = parcelRequire("fIcbd");


var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $dh538 = parcelRequire("dh538");




parcelRequire("42omo");







var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");

var $3sMdn = parcelRequire("3sMdn");


var $6R5uz = parcelRequire("6R5uz");


var $8tdj3 = parcelRequire("8tdj3");


var $28NpI = parcelRequire("28NpI");


var $56M4r = parcelRequire("56M4r");





var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");

var $39df32c904fddd23$exports = {};
$39df32c904fddd23$exports = new URL("dark-mode.c2768bcf.svg", import.meta.url).toString();


var $594cb8e7e219cbde$exports = {};
$594cb8e7e219cbde$exports = new URL("light-mode.e7c3914f.svg", import.meta.url).toString();


var $132df7341dd4843e$exports = {};
$132df7341dd4843e$exports = new URL("match-browser.a2bb9bea.svg", import.meta.url).toString();


const $4ae3fce8ce7f1b5d$var$messages = (0, $cgtv4.defineMessages)({
    themeButton: {
        id: "design-system.theme-switcher.theme-button",
        defaultMessage: "Theme"
    },
    light: {
        id: "design-system.theme-switcher.light.option",
        defaultMessage: "Light"
    },
    dark: {
        id: "design-system.theme-switcher.dark.option",
        defaultMessage: "Dark"
    },
    matchBrowser: {
        id: "design-system.theme-switcher.match-browser.option",
        defaultMessage: "Match browser"
    },
    matchSystem: {
        id: "design-system.theme-switcher.match-system.option",
        defaultMessage: "Match the system"
    },
    syncedAcrossApps: {
        id: "design-system.theme-switcher.synced-across-apps",
        defaultMessage: "Synced across apps"
    },
    personalize: {
        id: "design-system.theme-switcher.personalize",
        defaultMessage: "Personalize"
    }
});
const $4ae3fce8ce7f1b5d$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$4ae3fce8ce7f1b5d$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($594cb8e7e219cbde$exports)))
    },
    {
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$4ae3fce8ce7f1b5d$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($39df32c904fddd23$exports)))
    },
    {
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$4ae3fce8ce7f1b5d$var$messages.matchBrowser
        }),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($132df7341dd4843e$exports)))
    }
];
const $4ae3fce8ce7f1b5d$var$themeOptionsAutoFirst = [
    {
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$4ae3fce8ce7f1b5d$var$messages.matchSystem
        }),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($132df7341dd4843e$exports)))
    },
    {
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$4ae3fce8ce7f1b5d$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($594cb8e7e219cbde$exports)))
    },
    {
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$4ae3fce8ce7f1b5d$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($39df32c904fddd23$exports)))
    }
];
const $4ae3fce8ce7f1b5d$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentColorMode: currentColorMode, accountColorMode: accountColorMode, appearancePreferencesLink: appearancePreferencesLink, onOpenChange: onOpenChange })=>{
    const options = (0, $dh538.fg)('shared-user-preferences') ? $4ae3fce8ce7f1b5d$var$themeOptionsAutoFirst : $4ae3fce8ce7f1b5d$var$themeOptions;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            options.map(({ value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $l998X.jsx)("link", {
                    rel: "preload",
                    href: thumbnail,
                    as: "image"
                }, value)),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $52EPl.default), {
                testId: testId,
                placement: "auto-start",
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ref: triggerRef,
                        onClick: (event)=>event.stopPropagation(),
                        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($28NpI))), {
                            color: "currentColor",
                            label: ""
                        }),
                        iconAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                            color: "currentColor",
                            label: "",
                            size: "small"
                        }),
                        ...props,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...$4ae3fce8ce7f1b5d$var$messages.themeButton
                        })
                    }),
                shouldRenderToParent: false,
                children: [
                    options.map(({ label: label, value: value, thumbnail: thumbnail })=>{
                        const isSynced = accountColorMode !== undefined && accountColorMode === value;
                        const isSelected = currentColorMode === value;
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3sMdn.default), {
                            testId: `${testId}--radio-${value}`,
                            id: value,
                            onClick: ()=>onThemeChange(value),
                            isSelected: isSelected,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.150",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)("img", {
                                        src: thumbnail,
                                        width: 64,
                                        height: 48,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                        space: "space.025",
                                        children: [
                                            label,
                                            isSynced && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtlest",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                    ...$4ae3fce8ce7f1b5d$var$messages.syncedAcrossApps
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, value);
                    }),
                    appearancePreferencesLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                        hasSeparator: true,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                            href: appearancePreferencesLink,
                            target: "_blank",
                            rel: "noopener",
                            testId: testId && `${testId}--personalize`,
                            elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                                color: "currentColor",
                                label: "",
                                size: "small"
                            }),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...$4ae3fce8ce7f1b5d$var$messages.personalize
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $4ae3fce8ce7f1b5d$export$2e2bcd8739ae039 = $4ae3fce8ce7f1b5d$export$9d63163ee2173b37;



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $7sObp = parcelRequire("7sObp");










/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line no-restricted-imports






parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");





var $gdv5Z = parcelRequire("gdv5Z");


const $af0b6f5882cf7450$var$styles = {
    imgContainer: "_1bsbvbgk _4t3ivbgk _mezjvbgk _w8l5vbgk _bna7vbgk _1752vbgk",
    imgContainerSkeleton: "_2rko1rr0 _bfhki8nm",
    img: "_2rko1rr0 _1e0c1ule"
};
const $af0b6f5882cf7450$export$2d75367b6e042d67 = ({ testId: testId, src: src })=>{
    const state = (0, $581d0d4774eb5112$export$2c1df3428fc3264c)(src || '');
    const displayImage = src && state === 'loaded';
    const displayFallback = src && state === 'error';
    const displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: testId,
        xcss: (0, $1bHXt.cx)($af0b6f5882cf7450$var$styles.imgContainer, displaySkeleton && $af0b6f5882cf7450$var$styles.imgContainerSkeleton),
        children: [
            displayImage && /*#__PURE__*/ (0, $l998X.jsx)("img", {
                "data-testid": testId && `${testId}--img`,
                src: src,
                alt: "",
                className: (0, $gMc0m.default)([
                    $af0b6f5882cf7450$var$styles.img
                ])
            }),
            displayFallback && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
                spacing: "spacious",
                testId: testId && `${testId}--fallback`,
                label: "",
                color: "var(--ds-text-subtlest, #6B6E76)"
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $kpYGL = parcelRequire("kpYGL");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $947a2399b57871ec$var$SkeletonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $947a2399b57871ec$export$cb6ddd830302c2a8 = ({ length: length })=>/*#__PURE__*/ (0, $l998X.jsx)($947a2399b57871ec$var$SkeletonWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
            width: length,
            height: "1em",
            borderRadius: "0.5em"
        })
    });


const $9f54f6e7b6ed0a29$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy })=>/*#__PURE__*/ (0, $l998X.jsxs)($9f54f6e7b6ed0a29$var$Container, {
        "data-testid": testId,
        children: [
            managedBy && /*#__PURE__*/ (0, $l998X.jsxs)($9f54f6e7b6ed0a29$var$ManagedBy, {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($9f54f6e7b6ed0a29$var$PersonIconWrapper, {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                            color: "currentColor",
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        id: "identity.account-menu.account-menu-details.managed-account",
                        defaultMessage: "This account is managed by <b>{managedBy}</b>",
                        values: {
                            b: (text)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    as: "strong",
                                    size: "small",
                                    color: "inherit",
                                    children: text
                                }),
                            managedBy: managedBy
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($9f54f6e7b6ed0a29$var$Content, {
                hasHeader: !!managedBy,
                children: /*#__PURE__*/ (0, $l998X.jsx)($9f54f6e7b6ed0a29$var$Profile, {
                    testId: testId,
                    name: name,
                    picture: picture,
                    email: email
                })
            })
        ]
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _19pkidpf _2hwxu2gc _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$ManagedBy = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cp8ho _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc _y3gn1h6o _13lifajl _qrwqfajl _mrkbidpf _1o0zidpf _bfhk19ip _syazazsu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$PersonIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx1b66 _nbgx1crf _1f021crf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$Content = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasHeader: hasHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1xsu82h": (0, $7sObp.default)(__cmplp.hasHeader ? `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}` : "var(--ds-radius-small, 3px)")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko107z _1e0c1txw _2lx21bp4 _bfhkhfxm",
            __cmplp.className
        ])
    });
});
const $9f54f6e7b6ed0a29$var$Profile = ({ name: name, email: email, picture: picture, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsxs)($9f54f6e7b6ed0a29$var$ProfileWrapper, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $af0b6f5882cf7450$export$2d75367b6e042d67), {
                src: picture,
                testId: testId && `${testId}--picture`
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)($9f54f6e7b6ed0a29$var$NameAndEmail, {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($9f54f6e7b6ed0a29$var$DisplayName, {
                        "data-testid": testId && `${testId}--name`,
                        children: name || /*#__PURE__*/ (0, $l998X.jsx)((0, $947a2399b57871ec$export$cb6ddd830302c2a8), {
                            length: "6em"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($9f54f6e7b6ed0a29$var$EmailAddress, {
                        "data-testid": testId && `${testId}--email`,
                        children: email || /*#__PURE__*/ (0, $l998X.jsx)((0, $947a2399b57871ec$export$cb6ddd830302c2a8), {
                            length: "10em"
                        })
                    })
                ]
            })
        ]
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$ProfileWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$NameAndEmail = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _19pk1wug _2hwxidpf _otyr1wug _18u0pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$DisplayName = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazi7uo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$EmailAddress = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkv77o _syaz1rpy _k48pi7a9",
            __cmplp.className
        ])
    });
});





parcelRequire("42omo");


































var $791e151635716c6e$exports = {};
$791e151635716c6e$exports = new URL("dark-mode.c2768bcf.svg", import.meta.url).toString();


var $f119b6b1b2c40e58$exports = {};
$f119b6b1b2c40e58$exports = new URL("light-mode.e7c3914f.svg", import.meta.url).toString();


var $e93ffcb45d34da98$exports = {};
$e93ffcb45d34da98$exports = new URL("match-browser.a2bb9bea.svg", import.meta.url).toString();


const $a29165a1bb79a351$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme, globalColorMode: globalColorMode, appearancePreferencesLink: appearancePreferencesLink, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            $a29165a1bb79a351$var$themeOptions.map(({ value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $l998X.jsx)("link", {
                    rel: "preload",
                    href: thumbnail,
                    as: "image"
                }, value)),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $52EPl.default), {
                testId: testId,
                placement: "auto-start",
                onOpenChange: onThemeSwitcherOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ref: triggerRef,
                        onClick: (event)=>event.stopPropagation(),
                        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($28NpI))), {
                            color: "currentColor",
                            label: ""
                        }),
                        iconAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                            color: "currentColor",
                            label: "",
                            size: "small"
                        }),
                        ...props,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            id: "identity.account-menu.theme-switcher.theme-button",
                            defaultMessage: "Theme"
                        })
                    }),
                shouldRenderToParent: false,
                children: [
                    $a29165a1bb79a351$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>{
                        const isSynced = globalColorMode !== undefined && globalColorMode === value;
                        const isSelected = currentTheme === value;
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3sMdn.default), {
                            testId: `${testId}--radio-${value}`,
                            id: value,
                            onClick: ()=>onThemeChange(value),
                            isSelected: isSelected,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.150",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)("img", {
                                        src: thumbnail,
                                        width: 64,
                                        height: 48,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                        space: "space.025",
                                        children: [
                                            label,
                                            isSynced && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtlest",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                    ...$a29165a1bb79a351$var$messages.syncedAcrossApps
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, value);
                    }),
                    appearancePreferencesLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                        hasSeparator: true,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                            href: appearancePreferencesLink,
                            target: "_blank",
                            rel: "noopener",
                            testId: testId && `${testId}--personalize`,
                            elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                                color: "currentColor",
                                label: "",
                                size: "small"
                            }),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...$a29165a1bb79a351$var$messages.personalize
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $a29165a1bb79a351$var$messages = (0, $cgtv4.defineMessages)({
    light: {
        id: "identity.account-menu.theme-switcher.light.option",
        defaultMessage: "Light"
    },
    dark: {
        id: "identity.account-menu.theme-switcher.dark.option",
        defaultMessage: "Dark"
    },
    matchBrowser: {
        id: "identity.account-menu.theme-switcher.match-browser.option",
        defaultMessage: "Match browser"
    },
    syncedAcrossApps: {
        id: "identity.account-menu.theme-switcher.synced-across-apps",
        defaultMessage: "Synced across apps"
    },
    personalize: {
        id: "identity.account-menu.theme-switcher.personalize",
        defaultMessage: "Personalize"
    }
});
const $a29165a1bb79a351$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$a29165a1bb79a351$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($f119b6b1b2c40e58$exports)))
    },
    {
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$a29165a1bb79a351$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($791e151635716c6e$exports)))
    },
    {
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$a29165a1bb79a351$var$messages.matchBrowser
        }),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($e93ffcb45d34da98$exports)))
    }
];


const $32d891c6a46c5c31$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, globalColorMode: globalColorMode, extraMenuItems: extraMenuItems = null, onLogoutClick: onLogoutClick, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange })=>{
    const themeSwitcherProps = onThemeChange && currentTheme;
    const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, $l998X.jsx)($32d891c6a46c5c31$var$Container, {
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $2SlZp.default), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9f54f6e7b6ed0a29$export$66e04d0aacdb3b2), {
                        testId: testId && `${testId}--details`,
                        name: name,
                        picture: picture,
                        email: email,
                        managedBy: managedBy
                    })
                }),
                shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
                    children: [
                        viewProfileLink && /*#__PURE__*/ (0, $l998X.jsx)($32d891c6a46c5c31$var$ViewProfileLink, {
                            onClick: onViewProfileClick,
                            testId: testId && `${testId}--view-profile`,
                            href: viewProfileLink,
                            closePopup: closePopup
                        }),
                        manageProfileLink && /*#__PURE__*/ (0, $l998X.jsx)($32d891c6a46c5c31$var$ManageProfileLink, {
                            testId: testId && `${testId}--manage-profile`,
                            href: manageProfileLink,
                            closePopup: closePopup
                        }),
                        themeSwitcherProps && ((0, $dh538.fg)('replace-account-menu-theme-switcher') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4ae3fce8ce7f1b5d$export$9d63163ee2173b37), {
                            testId: testId && `${testId}--theme-switcher`,
                            onThemeChange: onThemeChange,
                            currentColorMode: currentTheme,
                            accountColorMode: globalColorMode ?? undefined,
                            onOpenChange: onThemeSwitcherOpenChange,
                            appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink?.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $a29165a1bb79a351$export$9d63163ee2173b37), {
                            testId: testId && `${testId}--theme-switcher`,
                            onThemeChange: onThemeChange,
                            currentTheme: currentTheme,
                            globalColorMode: globalColorMode,
                            onThemeSwitcherOpenChange: onThemeSwitcherOpenChange,
                            appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink?.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
                        }))
                    ]
                }),
                extraMenuItems,
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
                    hasSeparator: shouldRenderProfileThemeSwitcherSection,
                    children: [
                        switchAccountLink && /*#__PURE__*/ (0, $l998X.jsx)($32d891c6a46c5c31$var$SwitchAccountLink, {
                            testId: testId && `${testId}--switch-account`,
                            href: switchAccountLink,
                            closePopup: closePopup
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)($32d891c6a46c5c31$var$LogOutLink, {
                            testId: testId && `${testId}--log-out`,
                            href: logOutLink,
                            closePopup: closePopup,
                            onClick: onLogoutClick
                        })
                    ]
                })
            ]
        })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32d891c6a46c5c31$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_vchhusvi _1ul9ko4j",
            __cmplp.className
        ])
    });
});
const $32d891c6a46c5c31$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>/*#__PURE__*/ (0, $l998X.jsx)($32d891c6a46c5c31$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            id: "identity.account-menu.account-details.view-profile-tooltip",
            defaultMessage: "Profile"
        })
    });
const $32d891c6a46c5c31$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $l998X.jsx)($32d891c6a46c5c31$var$Link, {
        testId: testId,
        href: href,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            id: "identity.account-menu.account-details.manage-profile-link",
            defaultMessage: "Account settings"
        })
    });
const $32d891c6a46c5c31$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $l998X.jsx)($32d891c6a46c5c31$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            id: "identity.account-menu.account-menu-content.switch-account-button",
            defaultMessage: "Switch account"
        })
    });
const $32d891c6a46c5c31$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup, onClick: onClick })=>/*#__PURE__*/ (0, $l998X.jsx)($32d891c6a46c5c31$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jK29N))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            id: "identity.account-menu.account-menu-content.log-out-button",
            defaultMessage: "Log out"
        })
    });
const $32d891c6a46c5c31$var$Link = ({ testId: testId, closePopup: closePopup, icon: icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'menuLinkItem',
            actionSubjectId: actionSubjectId
        });
        const clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $07093422fbc04e7e$export$515664faa1398f37));
        onClick?.(event, analyticsEvent);
        closePopup?.(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        testId: testId,
        iconBefore: icon,
        href: href,
        onClick: handleClick,
        ...props,
        children: children
    });
};









var $1e2E5 = parcelRequire("1e2E5");



/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $6d8a7a824f3555db$var$lazyMessages = {
    cs: ()=>(parcelRequire("hgnLB")),
    cs_CZ: ()=>(parcelRequire("gXIyP")),
    da: ()=>(parcelRequire("iC3rN")),
    da_DK: ()=>(parcelRequire("2WcJE")),
    de: ()=>(parcelRequire("fCWG9")),
    de_DE: ()=>(parcelRequire("hCY1O")),
    en_GB: ()=>(parcelRequire("6TyPk")),
    en_ZZ: ()=>(parcelRequire("hin5z")),
    es: ()=>(parcelRequire("i1S0z")),
    fi: ()=>(parcelRequire("dOK5E")),
    fi_FI: ()=>(parcelRequire("6yCAx")),
    fr: ()=>(parcelRequire("jSBC4")),
    fr_FR: ()=>(parcelRequire("9Xulk")),
    hu: ()=>(parcelRequire("d8ofW")),
    hu_HU: ()=>(parcelRequire("1H5B6")),
    it: ()=>(parcelRequire("3QZgn")),
    it_IT: ()=>(parcelRequire("2nshR")),
    ja: ()=>(parcelRequire("6B81f")),
    ja_JP: ()=>(parcelRequire("9I0AJ")),
    ko: ()=>(parcelRequire("kDm2L")),
    ko_KR: ()=>(parcelRequire("3KJEk")),
    nb: ()=>(parcelRequire("ax516")),
    nb_NO: ()=>(parcelRequire("8Y6wK")),
    nl: ()=>(parcelRequire("gRCOE")),
    nl_NL: ()=>(parcelRequire("d95cT")),
    pl: ()=>(parcelRequire("ke7Lq")),
    pl_PL: ()=>(parcelRequire("juDWC")),
    pt_BR: ()=>(parcelRequire("5xRO5")),
    ru: ()=>(parcelRequire("ikyPh")),
    ru_RU: ()=>(parcelRequire("27TTS")),
    sv: ()=>(parcelRequire("8JTON")),
    sv_SE: ()=>(parcelRequire("b3aF0")),
    th: ()=>(parcelRequire("NMk0d")),
    th_TH: ()=>(parcelRequire("ibzGt")),
    tr: ()=>(parcelRequire("dROG2")),
    tr_TR: ()=>(parcelRequire("iovpR")),
    uk: ()=>(parcelRequire("b4xAl")),
    uk_UA: ()=>(parcelRequire("kG7Lp")),
    vi: ()=>(parcelRequire("5JTw9")),
    vi_VN: ()=>(parcelRequire("3XeuJ")),
    zh: ()=>(parcelRequire("ckmt9")),
    zh_CN: ()=>(parcelRequire("amcN0")),
    zh_TW: ()=>(parcelRequire("5PKX5"))
};
var $6d8a7a824f3555db$export$2e2bcd8739ae039 = $6d8a7a824f3555db$var$lazyMessages;



var $kyRHQ = parcelRequire("kyRHQ");

const $7907dead2a23af82$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const messages = $7907dead2a23af82$var$useMessages(locale);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale,
        messages: messages,
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($kyRHQ?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        },
        children: children
    });
};
const $7907dead2a23af82$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $7907dead2a23af82$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $7907dead2a23af82$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $6d8a7a824f3555db$export$2e2bcd8739ae039)[`${language}_${region}`] || (0, $6d8a7a824f3555db$export$2e2bcd8739ae039)[language])?.())?.default;
};












var $Asv1P = parcelRequire("Asv1P");





var $lGgRw = parcelRequire("lGgRw");


const $0a9efcd3d36ca5be$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content, trustPicture: trustPicture = false, AccountMenuTrigger: AccountMenuTrigger })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const close = (0, $Asv1P.useCallbackWithAnalytics)(()=>setIsOpen(false), {
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'closed',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $07093422fbc04e7e$export$515664faa1398f37));
    const open = (0, $Asv1P.useCallbackWithAnalytics)(()=>setIsOpen(true), {
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'opened',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $07093422fbc04e7e$export$515664faa1398f37));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)(AccountMenuTrigger, {
                onClick: isOpen ? close : open,
                testId: testId && `${testId}--trigger`,
                picture: picture,
                email: email,
                trustPicture: trustPicture,
                ...triggerProps
            }),
        content: content,
        shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-identity-ki')
    });
};


const $1593f61e84401b5f$export$ff20d75d5eda4388 = ({ testId: testId, globalColorMode: globalColorMode, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems, trustPicture: trustPicture = false, onLogoutClick: onLogoutClick, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange, AccountMenuLoggedOutState: AccountMenuLoggedOutState, AccountMenuTrigger: AccountMenuTrigger })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: (0, $07093422fbc04e7e$export$3cbe56a0cabcff38),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7907dead2a23af82$export$6c1f1571e3dd1b34), {
            children: logInLink ? /*#__PURE__*/ (0, $l998X.jsx)(AccountMenuLoggedOutState, {
                testId: testId && `${testId}--logged-out-state`,
                logInLink: logInLink
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $0a9efcd3d36ca5be$export$473cb05bf335b0e1), {
                testId: testId,
                picture: picture,
                trustPicture: trustPicture,
                email: email,
                AccountMenuTrigger: AccountMenuTrigger,
                content: ({ onClose: closePopup })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $32d891c6a46c5c31$export$49c2771125e1e9f1), {
                        testId: testId && `${testId}--content`,
                        closePopup: closePopup,
                        globalColorMode: globalColorMode,
                        name: name,
                        picture: picture,
                        email: email,
                        managedBy: managedBy,
                        manageProfileLink: manageProfileLink,
                        viewProfileLink: viewProfileLink,
                        onViewProfileClick: onViewProfileClick,
                        switchAccountLink: switchAccountLink,
                        logOutLink: logOutLink,
                        onThemeChange: onThemeChange,
                        currentTheme: currentTheme,
                        extraMenuItems: extraMenuItems,
                        onLogoutClick: onLogoutClick,
                        onThemeSwitcherOpenChange: onThemeSwitcherOpenChange
                    })
            })
        })
    });


const $a5cc9a5330823789$export$4ff56e5cf713dc64 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1593f61e84401b5f$export$ff20d75d5eda4388), {
        ...props,
        AccountMenuLoggedOutState: (0, $739c14dbd5941201$export$5e6158d2118ae4aa),
        AccountMenuTrigger: (0, $84a2e3c47e22a026$export$89d857133932d6aa)
    });
};
module.exports["AccountMenuNav3"] = $a5cc9a5330823789$export$4ff56e5cf713dc64;

});

parcelRegister("hgnLB", function(module, exports) {

let $c9165de1fd19d0aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9165de1fd19d0aa$var$load("49f46").then(()=>parcelRequire('5IqdJ'));

});

parcelRegister("gXIyP", function(module, exports) {

let $c594b8e23ab461f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c594b8e23ab461f8$var$load("jQPB7").then(()=>parcelRequire('fayG1'));

});

parcelRegister("iC3rN", function(module, exports) {

let $d8ce732e2771cf35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d8ce732e2771cf35$var$load("88bR1").then(()=>parcelRequire('UHBCO'));

});

parcelRegister("2WcJE", function(module, exports) {

let $223ae0854697cc03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $223ae0854697cc03$var$load("bwD1u").then(()=>parcelRequire('9pe3F'));

});

parcelRegister("fCWG9", function(module, exports) {

let $b607ec0c81782ddf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b607ec0c81782ddf$var$load("85kOD").then(()=>parcelRequire('1pUDx'));

});

parcelRegister("hCY1O", function(module, exports) {

let $cd548ca5bd8bf9b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd548ca5bd8bf9b7$var$load("R2BG5").then(()=>parcelRequire('iqlPg'));

});

parcelRegister("6TyPk", function(module, exports) {

let $5052e50840868fe9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5052e50840868fe9$var$load("2goda").then(()=>parcelRequire('iOI8t'));

});

parcelRegister("hin5z", function(module, exports) {

let $c976070bd5947707$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c976070bd5947707$var$load("gjxqp").then(()=>parcelRequire('bhbO7'));

});

parcelRegister("i1S0z", function(module, exports) {

let $d20236ea4ee78384$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d20236ea4ee78384$var$load("1S2jF").then(()=>parcelRequire('edwAF'));

});

parcelRegister("dOK5E", function(module, exports) {

let $a0f3b26839dd5fc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0f3b26839dd5fc9$var$load("eERmJ").then(()=>parcelRequire('e4doi'));

});

parcelRegister("6yCAx", function(module, exports) {

let $4c63d9e0103e0cbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c63d9e0103e0cbf$var$load("8rk64").then(()=>parcelRequire('6dE10'));

});

parcelRegister("jSBC4", function(module, exports) {

let $e7903c9f689799f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7903c9f689799f2$var$load("bpktO").then(()=>parcelRequire('gBarX'));

});

parcelRegister("9Xulk", function(module, exports) {

let $7401293b640f6d25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7401293b640f6d25$var$load("aC2ty").then(()=>parcelRequire('donzV'));

});

parcelRegister("d8ofW", function(module, exports) {

let $98fed67ff57679f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98fed67ff57679f4$var$load("lmJBr").then(()=>parcelRequire('dMOpd'));

});

parcelRegister("1H5B6", function(module, exports) {

let $13be262348105b8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $13be262348105b8b$var$load("lVBNt").then(()=>parcelRequire('h0DUZ'));

});

parcelRegister("3QZgn", function(module, exports) {

let $2ce5c0083697a7f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ce5c0083697a7f8$var$load("lnHpS").then(()=>parcelRequire('edoS5'));

});

parcelRegister("2nshR", function(module, exports) {

let $1bb3abfb62ee6865$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1bb3abfb62ee6865$var$load("kEBAh").then(()=>parcelRequire('1MVOF'));

});

parcelRegister("6B81f", function(module, exports) {

let $4cdc6b3276558913$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4cdc6b3276558913$var$load("3ZAy1").then(()=>parcelRequire('gyzZK'));

});

parcelRegister("9I0AJ", function(module, exports) {

let $7118ae922f32630b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7118ae922f32630b$var$load("fDXOw").then(()=>parcelRequire('k5CKC'));

});

parcelRegister("kDm2L", function(module, exports) {

let $f0588c8ed83489e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0588c8ed83489e0$var$load("45dhs").then(()=>parcelRequire('dbyax'));

});

parcelRegister("3KJEk", function(module, exports) {

let $2bb914069dda799c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bb914069dda799c$var$load("grGen").then(()=>parcelRequire('aADgd'));

});

parcelRegister("ax516", function(module, exports) {

let $7ab0e0aa65b3a188$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ab0e0aa65b3a188$var$load("4iqE9").then(()=>parcelRequire('AmvTn'));

});

parcelRegister("8Y6wK", function(module, exports) {

let $6878fd7ff1067be6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6878fd7ff1067be6$var$load("bAyJY").then(()=>parcelRequire('2bGC8'));

});

parcelRegister("gRCOE", function(module, exports) {

let $c46fb4a4adb3b62a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c46fb4a4adb3b62a$var$load("51EOq").then(()=>parcelRequire('9SCOA'));

});

parcelRegister("d95cT", function(module, exports) {

let $992027a31f0a7a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $992027a31f0a7a65$var$load("d5GjE").then(()=>parcelRequire('3ahnS'));

});

parcelRegister("ke7Lq", function(module, exports) {

let $eb9b23396d135bb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb9b23396d135bb3$var$load("4ILPZ").then(()=>parcelRequire('6UenK'));

});

parcelRegister("juDWC", function(module, exports) {

let $e30fcdcfc2c6349f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e30fcdcfc2c6349f$var$load("6QVYs").then(()=>parcelRequire('9rAua'));

});

parcelRegister("5xRO5", function(module, exports) {

let $4099c5bc391130cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4099c5bc391130cf$var$load("7HuII").then(()=>parcelRequire('46yCo'));

});

parcelRegister("ikyPh", function(module, exports) {

let $d5851bfd76ad5064$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5851bfd76ad5064$var$load("iYxvq").then(()=>parcelRequire('9AItb'));

});

parcelRegister("27TTS", function(module, exports) {

let $18c798d54204551f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18c798d54204551f$var$load("8kHli").then(()=>parcelRequire('c4u14'));

});

parcelRegister("8JTON", function(module, exports) {

let $65cdd307bc33922a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65cdd307bc33922a$var$load("dqRWB").then(()=>parcelRequire('jiubQ'));

});

parcelRegister("b3aF0", function(module, exports) {

let $80b83e796fafb266$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80b83e796fafb266$var$load("bYWK5").then(()=>parcelRequire('cDjZR'));

});

parcelRegister("NMk0d", function(module, exports) {

let $095a0f62ba59b60f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $095a0f62ba59b60f$var$load("k0u9s").then(()=>parcelRequire('ix6Ww'));

});

parcelRegister("ibzGt", function(module, exports) {

let $d3d4ef2f1c4315d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d3d4ef2f1c4315d3$var$load("imObn").then(()=>parcelRequire('hIGnW'));

});

parcelRegister("dROG2", function(module, exports) {

let $a18788fc434210e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a18788fc434210e4$var$load("chSc4").then(()=>parcelRequire('10LAa'));

});

parcelRegister("iovpR", function(module, exports) {

let $d642d67c3bdacd16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d642d67c3bdacd16$var$load("dfeY8").then(()=>parcelRequire('hvJbJ'));

});

parcelRegister("b4xAl", function(module, exports) {

let $80fa1ebede4c4fb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80fa1ebede4c4fb9$var$load("fvaoj").then(()=>parcelRequire('3mPtI'));

});

parcelRegister("kG7Lp", function(module, exports) {

let $f0ddc09aa2c255fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0ddc09aa2c255fa$var$load("lT1ej").then(()=>parcelRequire('6zPsL'));

});

parcelRegister("5JTw9", function(module, exports) {

let $42dc3855ec3a8378$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $42dc3855ec3a8378$var$load("8OH5J").then(()=>parcelRequire('jUZEM'));

});

parcelRegister("3XeuJ", function(module, exports) {

let $2e122026d255fbd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2e122026d255fbd8$var$load("hV9Rr").then(()=>parcelRequire('3Nmej'));

});

parcelRegister("ckmt9", function(module, exports) {

let $8f98c830d9940b9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f98c830d9940b9a$var$load("k4zbq").then(()=>parcelRequire('cMIbn'));

});

parcelRegister("amcN0", function(module, exports) {

let $78a5e12b78320b9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78a5e12b78320b9f$var$load("1cNBX").then(()=>parcelRequire('9Z0w0'));

});

parcelRegister("5PKX5", function(module, exports) {

let $43f622ddf5b0d64e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $43f622ddf5b0d64e$var$load("ii6TT").then(()=>parcelRequire('hru40'));

});

parcelRegister("ictHB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");


var $l7ck4 = parcelRequire("l7ck4");


var $eSUdr = parcelRequire("eSUdr");

const $c9f8bd21a9d5ab42$export$2af2da09d11f65c9 = (0, $eSUdr.default)`query GlobalThemePreferenceQuery($accountId:ID!){settings_userPreferencesGlobal(accountId:$accountId){theme}}`;


const $15802750adf7cbc3$var$DEFAULT_COLOR_MODE = 'auto'; /**
                                                     * Fetches the global (account-level) theme preference from AGG.
                                                     * This is a non-hook function that can be used outside of React components or passed to useColorModeState from @atlassian/shared-user-preferences-api.
                                                     *
                                                     * @param accountId - The user's account ID
                                                     * @returns Promise that resolves to a partial ThemeState with the user's global color mode preference, or undefined if not available
                                                     */ 
const $15802750adf7cbc3$export$812fe4c912218d94 = async (accountId)=>{
    // Return undefined if no account ID
    if (!accountId) return undefined;
    try {
        // Query AGG for the user's global (account-level) theme preference
        const client = (0, $gKr8t.getAGGClient)(); // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await client.query({
            query: (0, $c9f8bd21a9d5ab42$export$2af2da09d11f65c9),
            variables: {
                accountId: accountId
            },
            fetchPolicy: 'cache-first'
        });
        const themeString = data?.settings_userPreferencesGlobal?.theme;
        if (themeString) {
            const themeObject = (0, $j6S25.themeStringToObject)(themeString);
            return {
                colorMode: themeObject.colorMode || $15802750adf7cbc3$var$DEFAULT_COLOR_MODE
            };
        } else // Data loaded but no theme string
        return {
            colorMode: $15802750adf7cbc3$var$DEFAULT_COLOR_MODE
        };
    } catch (error) {
        // Report query errors to analytics
        (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).useGlobalColorMode, (0, $l7ck4.ErrorSubjectIds).apolloQueryErrors, {
            accountId: accountId,
            error: error.message,
            errorName: error.name
        });
        return {
            colorMode: $15802750adf7cbc3$var$DEFAULT_COLOR_MODE
        };
    }
};
const $15802750adf7cbc3$export$b766b4e8fd5a2dbe = (accountId)=>{
    const [colorMode, setColorMode] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        // Skip if feature flag is disabled or no account ID
        if (!(0, $9wGTI.fg)('shared-user-preferences') || !accountId) return;
         // Use the extracted fetch function
        $15802750adf7cbc3$export$812fe4c912218d94(accountId).then((theme)=>{
            if (theme?.colorMode) setColorMode(theme.colorMode);
            else setColorMode($15802750adf7cbc3$var$DEFAULT_COLOR_MODE);
        }).catch((error)=>{
            // This shouldn't happen as fetchGlobalColorMode handles errors internally,
            // but handle it just in case
            (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).useGlobalColorMode, (0, $l7ck4.ErrorSubjectIds).apolloQueryErrors, {
                accountId: accountId,
                error: error.message,
                errorName: error.name
            });
            setColorMode($15802750adf7cbc3$var$DEFAULT_COLOR_MODE);
        });
    }, [
        accountId
    ]);
    // Return undefined if feature flag is disabled
    return (0, $9wGTI.fg)('shared-user-preferences') ? colorMode : undefined;
};
module.exports["fetchGlobalColorMode"] = $15802750adf7cbc3$export$812fe4c912218d94;

});

parcelRegister("disnP", function(module, exports) {
/**
 * @generated SignedSource<<159d531b28047d0c91318631e195b31f>>
 * @relayHash de15b354a95e769123fe60dd15a7f8cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c25b80273fbbe1163657875e0d88e9dc3cbe805468bd71ed9c234670648be2d1
const $a0e70be4605380bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "SettingsUserPreferences",
            "kind": "LinkedField",
            "name": "settings_userPreferencesGlobal",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "theme"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "globalThemeManagementGetPreferenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "globalThemeManagementGetPreferenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "c25b80273fbbe1163657875e0d88e9dc3cbe805468bd71ed9c234670648be2d1",
            "metadata": {},
            "name": "globalThemeManagementGetPreferenceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a0e70be4605380bf$var$node.hash = "82db627aaf32cacee0220d3e6d6a9c59";
var $a0e70be4605380bf$export$2e2bcd8739ae039 = $a0e70be4605380bf$var$node;



var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $j6S25 = parcelRequire("j6S25");

const $2ac392a1e93c70f7$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $2ac392a1e93c70f7$export$854b45b62d1eb6d4 = 'auto';
const $2ac392a1e93c70f7$export$2faeed762aac6741 = {
    dark: 'dark',
    light: 'light',
    colorMode: $2ac392a1e93c70f7$export$854b45b62d1eb6d4,
    typography: 'typography'
};


const $8683bd0f8e4b3b8c$export$bc77b52491b156d8 = (themeString)=>{
    const themeObject = (0, $j6S25.themeStringToObject)(themeString); // Return theme object with default values
    return {
        ...(0, $2ac392a1e93c70f7$export$2faeed762aac6741),
        ...themeObject
    };
};


const $15d71dc1643c9a7e$export$9bf52df5fffb920b = async (environment, accountId)=>{
    if (!(0, $dh538.fg)('shared-user-preferences') || !accountId) return undefined;
    const response = await (0, $irOoi.fetchQuery)(environment, (0, $a0e70be4605380bf$export$2e2bcd8739ae039), {
        accountId: accountId
    }).toPromise();
    const themeString = response?.settings_userPreferencesGlobal?.theme;
    if (!themeString) return undefined;
    return (0, $8683bd0f8e4b3b8c$export$bc77b52491b156d8)(themeString);
};
const $15d71dc1643c9a7e$export$84de5a44b184e0f1 = (getThemePreference, accountId)=>{
    // null value is needed to indicate that the color mode has not been loaded yet - this way the theme switcher should render the appearancePreferencesLink.
    const [colorMode, setColorMode] = (0, $42omo.useState)(null);
    const hasLoaded = (0, $42omo.useRef)(false);
    const loadOnce = (0, $42omo.useCallback)(async ({ isOpen: isOpen })=>{
        if (isOpen && !hasLoaded.current) {
            hasLoaded.current = true;
            try {
                const theme = await getThemePreference();
                if (theme?.colorMode) setColorMode(theme.colorMode);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Failed to load theme preference:', error);
            }
        }
    }, [
        getThemePreference
    ]); // Return early if feature flag is disabled or accountId is null/undefined (after all hooks are called)
    if (!(0, $dh538.fg)('shared-user-preferences') || !accountId) return [
        undefined,
        undefined
    ];
    return [
        colorMode,
        loadOnce
    ];
};
const $15d71dc1643c9a7e$export$7e4f60ea87c9d425 = (environment, accountId)=>{
    const getThemePreference = (0, $42omo.useCallback)(()=>$15d71dc1643c9a7e$export$9bf52df5fffb920b(environment, accountId), [
        environment,
        accountId
    ]);
    return $15d71dc1643c9a7e$export$84de5a44b184e0f1(getThemePreference, accountId);
};
module.exports["useColorModeState"] = $15d71dc1643c9a7e$export$84de5a44b184e0f1;

});

parcelRegister("3yPEN", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $ilSNM = parcelRequire("ilSNM");


var $inPa6 = parcelRequire("inPa6");


var $8zu8b = parcelRequire("8zu8b");


var $56QzY = parcelRequire("56QzY");


var $dPJCf = parcelRequire("dPJCf");


var $jlIaF = parcelRequire("jlIaF");

const $bb152153185cb6ba$var$LOGIN_URL = typeof window !== 'undefined' ? `${0, $jlIaF.CONTEXT_PATH}/login.action?os_destination=${window.location.pathname.replace((0, $jlIaF.CONTEXT_PATH), '')}` : '';
const $bb152153185cb6ba$export$b78a3abd8101bea6 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== push || $[2] !== routeDataRef) {
        t0 = (e)=>{
            if (e.metaKey) window.open($bb152153185cb6ba$var$LOGIN_URL, "_blank", "noreferrer");
            else push($bb152153185cb6ba$var$LOGIN_URL);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "login",
                    attributes: {
                        selectedItemPageContext: routeDataRef.current?.routeName,
                        navigationLayer: "global",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = push;
        $[2] = routeDataRef;
        $[3] = t0;
    } else t0 = $[3];
    const onClick = t0;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bb152153185cb6ba$var$i18n.login);
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zu8b.EndItem), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ilSNM))),
            onClick: onClick,
            label: t1
        });
        $[5] = onClick;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = (e)=>{
        if (e.metaKey) window.open($bb152153185cb6ba$var$LOGIN_URL, '_blank', 'noreferrer');
        else push($bb152153185cb6ba$var$LOGIN_URL);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'login',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zu8b.EndItem), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ilSNM))),
        onClick: onClick,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bb152153185cb6ba$var$i18n.login)
    });
};
const $bb152153185cb6ba$var$i18n = (0, $cgtv4.defineMessages)({
    login: {
        id: "app-navigation.top-navigation.login",
        defaultMessage: "Log in"
    }
});
module.exports["LoginButton"] = $bb152153185cb6ba$export$b78a3abd8101bea6;

});

parcelRegister("eDVeb", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $cAraS = parcelRequire("cAraS");


var $M3hWz = parcelRequire("M3hWz");


var $5bPOK = parcelRequire("5bPOK");





var $kvBa6 = parcelRequire("kvBa6");


var $jmjWc = parcelRequire("jmjWc");


var $dPJCf = parcelRequire("dPJCf");


var $jlIaF = parcelRequire("jlIaF");


var $gz8ZY = parcelRequire("gz8ZY");


var $kysoj = parcelRequire("kysoj");

const $fdb2500e60d25720$export$8f0d616c2469c6b6 = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const inputRef = (0, $42omo.useRef)(null);
    const [customPlaceholder] = (0, $42omo.useState)(()=>(0, $kysoj.getPersistedGhostText)(inputRef));
    const onEnter = (0, $42omo.useCallback)((e)=>{
        const input = e.target;
        input.blur();
        push(`${(0, $jlIaF.CONTEXT_PATH)}/search/?text=${input.value}`);
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvBa6.QuickFindSkeleton), {
        onEnter: onEnter,
        isNav4Enabled: isNav4Enabled,
        customPlaceholder: customPlaceholder,
        inputRef: inputRef
    });
};

const $fdb2500e60d25720$export$96939788a99e8cd1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CSp8g",
    name: "QuickFindAsync",
    loader: async ()=>(await Promise.resolve((parcelRequire("4jplB")))).QuickFind,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdb2500e60d25720$export$8f0d616c2469c6b6, null)
});



var $fsMoS = parcelRequire("fsMoS");





var $e4o8D = parcelRequire("e4o8D");

const $eb2a5d9806ae71d8$export$79d13b60110f33be = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const theme = (0, $cAraS.useLegacySearchTheme)();
    const [isQuickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t0;
    if ($[0] !== renderServerPlaceholder || $[1] !== theme) {
        t0 = ()=>renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $M3hWz.ProductSearchInputSkeletonInteractiveSSR), {
                placeholder: "Search",
                advancedSearchUrl: `${(0, $jlIaF.CONTEXT_PATH)}/search`,
                shouldFillContainer: true
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fsMoS.NavigationSearchDialog), {
                shouldFillContainer: true,
                theme: theme
            });
        $[0] = renderServerPlaceholder;
        $[1] = theme;
        $[2] = t0;
    } else t0 = $[2];
    const renderSearchBar = t0;
    const renderQuickFind = $eb2a5d9806ae71d8$var$_temp;
    const t1 = isQuickFindEnabled && $eb2a5d9806ae71d8$var$flexStyles;
    let t2;
    if ($[3] !== t1) {
        t2 = [
            $eb2a5d9806ae71d8$var$searchBarWrapper,
            t1
        ];
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isQuickFindEnabled || $[6] !== renderSearchBar) {
        t3 = isQuickFindEnabled ? renderQuickFind() : renderSearchBar();
        $[5] = isQuickFindEnabled;
        $[6] = renderSearchBar;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t2
        }, t3);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ()=>{
    const theme = (0, $cAraS.useLegacySearchTheme)();
    const [isQuickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const renderSearchBar = ()=>{
        return renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $M3hWz.ProductSearchInputSkeletonInteractiveSSR), {
            placeholder: "Search",
            advancedSearchUrl: `${(0, $jlIaF.CONTEXT_PATH)}/search`,
            shouldFillContainer: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fsMoS.NavigationSearchDialog), {
            shouldFillContainer: true,
            theme: theme
        });
    };
    const renderQuickFind = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdb2500e60d25720$export$96939788a99e8cd1), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $eb2a5d9806ae71d8$var$searchBarWrapper,
            isQuickFindEnabled && $eb2a5d9806ae71d8$var$flexStyles
        ]
    }, isQuickFindEnabled ? renderQuickFind() : renderSearchBar());
};
const $eb2a5d9806ae71d8$var$searchBarWrapper = (0, $ecnYn.xcss)({
    position: 'relative',
    width: '100%',
    maxWidth: '780px'
});
const $eb2a5d9806ae71d8$var$flexStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
});
function $eb2a5d9806ae71d8$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdb2500e60d25720$export$96939788a99e8cd1), null);
}
module.exports["SearchBar"] = $eb2a5d9806ae71d8$export$79d13b60110f33be;

});

parcelRegister("cAMBp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $blg7q = parcelRequire("blg7q");


var $aMqwg = parcelRequire("aMqwg");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $a043f210edc9881e$export$268af8ca93822c63 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(13);
    const { isLoggedIn: isLoggedIn, isRovoEnabled: isRovoEnabledSessionData, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== isRovoEnabledSessionData || $[1] !== isRovoLLMEnabled) {
        t0 = (0, $9wGTI.fg)("rovo_use_rovo_llm_enabled_check") ? isRovoLLMEnabled : isRovoEnabledSessionData;
        $[0] = isRovoEnabledSessionData;
        $[1] = isRovoLLMEnabled;
        $[2] = t0;
    } else t0 = $[2];
    const shouldShowRovo = t0;
    const isRovoEnabled = shouldShowRovo && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    let t1;
    let t2;
    if ($[3] !== isRovoEnabled) {
        t1 = ()=>{
            if (isRovoEnabled) (0, $6mKj3.expValEquals)("cc-aifc-databases-experiment", "isEnabled", true);
        };
        t2 = [
            isRovoEnabled
        ];
        $[3] = isRovoEnabled;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[6] !== isRovoEnabled) {
        t3 = isRovoEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $blg7q.ConversationAssistantNavBarButton), null);
        $[6] = isRovoEnabled;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== isRovoEnabled) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aMqwg.RovoEntitlementSetter), {
            isRovoEnabled: isRovoEnabled
        });
        $[8] = isRovoEnabled;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3, t4);
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ()=>{
    const { isLoggedIn: isLoggedIn, isRovoEnabled: isRovoEnabledSessionData, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabledSessionData;
    const isRovoEnabled = shouldShowRovo && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    (0, $42omo.useEffect)(()=>{
        if (isRovoEnabled) (0, $6mKj3.expValEquals)('cc-aifc-databases-experiment', 'isEnabled', true);
    }, [
        isRovoEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isRovoEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $blg7q.ConversationAssistantNavBarButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aMqwg.RovoEntitlementSetter), {
        isRovoEnabled: isRovoEnabled
    }));
};
module.exports["RovoButton"] = $a043f210edc9881e$export$268af8ca93822c63;

});

parcelRegister("cAraS", function(module, exports) {

var $aGop9 = parcelRequire("aGop9");


var $efXed = parcelRequire("efXed");

const $e261d37da5a7ee8e$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $e261d37da5a7ee8e$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused'; /**
                                                                                * Theme object intended for use with Search Platform components while transitioning to nav4.
                                                                                *
                                                                                * This is for backwards compatibility with the legacy theming API that was designed for nav3.
                                                                                *
                                                                                * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
                                                                                * at which point this legacy theme object will not be needed.
                                                                                */ 
const $e261d37da5a7ee8e$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$e261d37da5a7ee8e$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
    * When expanded the input ignores the custom theme,
    * except for its border which is derived from the highlight color.
    */ color: "var(--ds-text, #292A2E)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$e261d37da5a7ee8e$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$e261d37da5a7ee8e$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
    * This is not actually used for the search bar input (at least by the Search Platform components).
    *
    * Instead it's used as the hover background color for a close button when on mobile.
    */ backgroundColor: `var(${(0, $aGop9.themedButtonBackgroundHovered)})`
    }
};
function $e261d37da5a7ee8e$export$18a29b1ed2212823() {
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    if (hasCustomTheme) return $e261d37da5a7ee8e$var$legacySearchTheme;
    return undefined;
}
module.exports["themedSearchBorder"] = $e261d37da5a7ee8e$export$ae6fbf5ba3a7a784;
module.exports["themedSearchBorderFocused"] = $e261d37da5a7ee8e$export$ee42b8430f4c19bd;
module.exports["useLegacySearchTheme"] = $e261d37da5a7ee8e$export$18a29b1ed2212823;

});


//# sourceMappingURL=PageLayout.716014a8.js.map
